<template>
    <section class="page-manage container">
        <BaseButtonBack></BaseButtonBack>

        <Section>
            <SectionInfo slot="info" :title="'Integrations'" text="Setup your integrations"></SectionInfo>

            <template slot="categories">
                <SectionSettings 
                    :title="sections.upscribe.title"
                    :settings="sections.upscribe.settings"
                    @input="(val) => ( onInput(val, sections.upscribe.key) )"
                />
                <br/><br/>
                
                <BaseButton class="page-edit__save-btn" theme="primary" @click.native="save" title="Save" :loading="loading" v-if="integrations"></BaseButton>
            </template>
        </Section>

    <BaseHelpButton
      text="Learn more by reading our"
      icon="help"
      linkUrl="https://www.airfields.io/"
      linkLabel="documentation."/>
    </section>
</template>

<script>
import Store from '@/stores'
import { logger } from '@/helpers'
import Section from '@/components/Section'
import SectionInfo from '@/components/SectionInfo'
import SectionSettings from '@/components/SectionSettings'

export default {
    components: {
        Section,
        SectionInfo,
        SectionSettings
    },

    data () {
      return {
        store: this.$route.meta.store,
        loading: false,
      }
    },

    computed: {
        integrations: {
            get () {
                return { ...this.$store.getters[`${this.store}/integrations`] }
            },
        },
        sections() {
            return {
                upscribe: {
                    key: 'upscribe',
                    title: 'Enable Upscribe integration',
                    settings: [
                        { 
                            key: 'enabled',
                            label: 'Enabled',
                            title: 'Enable Upscribe integration',
                            type: 'boolean',
                            value: this.integrations.upscribe.settings.enabled,
                            subForm: {
                                onVal: "Yes",
                                offVal: "No"
                            }
                        }
                    ]
                }
            }
        }
    },
    methods: {
        onInput(val, key) {
            const integrations = this.mapValToIntegrations(val, key)
            this.$store.commit(`${this.store}/SET_INTEGRATIONS`, { integrations })
        },

        mapValToIntegrations(settings, key) {
            const integrations = { ...this.integrations }
            const integrationObj = { ...this.integrations[key] }

            settings.forEach(item => {
                integrationObj.settings[item.key] = item.value
            })

            integrations[ key ] = integrationObj
            return integrations
        },

        async save() {
            try {
                this.loading = true
                await this.$store.dispatch(`${this.store}/SAVE_SETTINGS`)

                this.$store.commit('banners/SHOW_BANNER', {
                    status: 'success',
                    title: 'Settings saved.'
                })
                this.$eventBus.$emit('AFTER_SAVE_SETTINGS')
            } catch (e) {
                logger(e, 'DEV')

                this.$store.commit('banners/SHOW_BANNER', {
                    status: 'warning',
                    title: 'Settings save failed.'
                })
            } finally {
                this.loading = false
            }
        },

        async handleWidnowEvent(e) {
            await this.save()
        },

        backToDashboard() {
            this.$router.push('/')
        },
    },

    async beforeRouteEnter(to, from, next) {
        try {
            await Store.dispatch(`${to.meta.store}/GET_SETTINGS`)
            next()
        } catch(error) {
            console.error(`Couldn't resolve ${to.name} beforeRouteEnter requests`, { error })
            next({
                name: 'app.error',
                query: { type: 'API' }
            })
        }
    },

    mounted() {
        window.addEventListener('save', this.handleWidnowEvent, false)
    },

    beforeDestroy() {
        window.removeEventListener('save', this.handleWidnowEvent)
        this.$store.commit('banners/CLOSE_BANNER')
    }
}
</script>

<style lang="scss">
@import './src/assets/styles/grid.scss';
@import './src/assets/styles/breakpoints.scss';

.page-manage {
    &__tree {
        @include media(ltMobile) {
            margin-left: -$container-gutter-mobile;
            margin-right: -$container-gutter-mobile;
        }
    }

    .page-manage__save-btn {
        display: flex;
        margin-left: auto;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/page-manage-integrations.vue